export default __webpack_public_path__ + "1a3b518de707cb5d474c810936180b87.svg";